import { render, staticRenderFns } from "./cpxl.vue?vue&type=template&id=50b85303&scoped=true&"
import script from "./cpxl.vue?vue&type=script&lang=js&"
export * from "./cpxl.vue?vue&type=script&lang=js&"
import style0 from "./cpxl.vue?vue&type=style&index=0&id=50b85303&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b85303",
  null
  
)

export default component.exports